import { memo } from "react";
import Separator from "../../../core/components/Separator.tsx";

function MotoristaEndereco({
    validator,
    setValues,
    setValidator,
    values,
    props,
    setTextoErro,
    setOpenToastErro,
}) {
    return (
        <>
            <Separator size="lg" />
            <div className="rota-div-2">
                <div className="coluna-emb">
                    <div>
                        <p className="input-label-emb" htmlFor="descricao">
                            Rua:
                        </p>
                        <input
                            type="text"
                            id="rua"
                            className="input-emb"
                            style={{
                                width: "250px",
                                borderColor:
                                    validator.validatorRua === "false" ? "red" : "",
                            }}
                            onChange={(e) => {
                                setValues((current) => ({
                                    ...current,
                                    rua: e.target.value,
                                }));
                                setValidator((current) => ({
                                    ...current,
                                    validatorRua: "true",
                                }));
                            }}
                            value={values.rua || ""}
                            disabled={props.desabilitar}
                        />
                        {validator.validatorRua === "false" && (
                            <p className="error-input-text">Rua inválida</p>
                        )}
                    </div>
                </div>
                <div className="coluna-emb">
                    <div>
                        <p className="input-label-emb" htmlFor="descricao">
                            Número:
                        </p>
                        <input
                            id="numero"
                            className="input-emb"
                            style={{
                                width: "250px",
                                borderColor:
                                    validator.validatorNumero === "false" ? "red" : "",
                            }}
                            type="number"
                            onChange={(e) => {
                                const value = e.target.value;
                                setValues((current) => ({
                                    ...current,
                                    numero: value,
                                }));
                                setValidator((current) => ({
                                    ...current,
                                    validatorNumero: "true",
                                }));
                            }}
                            value={values.numero}
                            disabled={props.desabilitar}
                        />
                        {validator.validatorNumero === "false" && (
                            <p className="error-input-text">Número inválido</p>
                        )}
                    </div>
                </div>
                <div className="coluna-emb">
                    <div>
                        <p className="input-label-emb" htmlFor="Bairro">
                            Bairro:
                        </p>
                        <input
                            type="text"
                            className="input-emb"
                            style={{
                                width: "250px",
                                borderColor:
                                    validator.validatorBairro === "false" ? "red" : "",
                            }}
                            onChange={(e) => {
                                setValues((current) => ({
                                    ...current,
                                    bairro: e.target.value,
                                }));
                                setValidator((current) => ({
                                    ...current,
                                    validatorBairro: "true",
                                }));
                            }}
                            value={values.bairro}
                            disabled={props.desabilitar}
                        />
                        {validator.validatorBairro === "false" && (
                            <p className="error-input-text">Bairro inválido</p>
                        )}
                    </div>
                </div>
            </div>
            <div className="rota-div-2">
                <div className="coluna-emb">
                    <div>
                        <p className="input-label-emb" htmlFor="descricao">
                            CEP:
                        </p>
                        <input
                            maxLength="8"
                            type="text"
                            id="cep"
                            className="input-emb"
                            style={{
                                width: "250px",
                                borderColor:
                                    validator.validatorCep === "false" ? "red" : "",
                            }}
                            onChange={(e) => {
                                let valor = e.target.value;
                                valor = valor.replace(/\D/g, "");
                                setValues((current) => ({
                                    ...current,
                                    cep: valor,
                                }));
                                setValidator((current) => ({
                                    ...current,
                                    validatorCep: "true",
                                }));
                            }}
                            onBlur={(e) => {
                                const cep = e.target.value;
                                if (!/^\d{8}$/.test(cep)) {
                                    setValidator((current) => ({
                                        ...current,
                                        validatorCep: "false",
                                    }));
                                    setTextoErro("CEP inválido");
                                    setOpenToastErro(true);
                                }
                            }}
                            value={values.cep || ""}
                            disabled={props.desabilitar}
                        />
                        {validator.validatorCep === "false" && (
                            <p className="error-input-text">CEP inválido</p>
                        )}
                    </div>
                </div>
                <div className="coluna-emb">
                    <div>
                        <p className="input-label-emb" htmlFor="descricao">
                            Cidade:
                        </p>
                        <input
                            type="text"
                            className="input-emb"
                            style={{
                                width: "250px",
                                borderColor:
                                    validator.validatorCidade === "false"
                                        ? "red"
                                        : "",
                            }}
                            onChange={(e) => {
                                setValues((current) => ({
                                    ...current,
                                    cidade: e.target.value,
                                }));
                                setValidator((current) => ({
                                    ...current,
                                    validatorCidade: "true",
                                }));
                            }}
                            value={values.cidade || ""}
                            disabled={props.desabilitar}
                        />
                        {validator.validatorCidade === "false" && (
                            <p className="error-input-text">Cidade inválida</p>
                        )}
                    </div>
                </div>
                <div className="coluna-emb">
                    <div>
                        <p className="input-label-emb" htmlFor="descricao">
                            Complemento:
                        </p>
                        <input
                            type="text"
                            id="complemento"
                            className="input-emb"
                            style={{ width: "250px" }}
                            onChange={(e) => {
                                setValues((current) => ({
                                    ...current,
                                    complemento: e.target.value,
                                }));
                            }}
                            value={values.complemento || ""}
                            disabled={props.desabilitar}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default memo(MotoristaEndereco)